$(document).ready(function () {
  var $carousel = $(".key_feature_points .grid");
  var isFlickityActive = false;

  function checkAndToggleFlickity() {
    var isMobile = window.innerWidth < 960;
    console.log("isMobile =", isMobile);

    if (isMobile && !isFlickityActive) {
      // Initialize Flickity on mobile
      $carousel.flickity({
        wrapAround: true,
        pageDots: false,
        initialIndex: 0,
        accessibility: true,
        autoPlay: false,
        groupCells: 1
      });
      isFlickityActive = true;
      console.log("Flickity initialized");
    } else if (!isMobile && isFlickityActive) {
      // Destroy Flickity on desktop
      $carousel.flickity("destroy");
      isFlickityActive = false;
      console.log("Flickity destroyed");
    }
  }

  // Run on load
  checkAndToggleFlickity();

  // Re-check on resize
  $(window).on("resize", function () {
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(checkAndToggleFlickity, 300);
  });
});
eme